import axios from "axios";

export const FormSubmit = (values, postURL, hostprops, action, errorf, successf) => {
    axios.post(
        postURL,
        //appConfig.apiGateway.updatePropertyReport,
        JSON.stringify({
            ...values, OrderId: hostprops.OrderId,
            OrderProductId: hostprops.OrderProductId,
            Action: action,
            UserName: hostprops.session.session.user.name
        }),
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${hostprops.session.session.credentials.accessToken}`
            }
        }
    ).then((response) => {
        if (response.data.Count > 0) {
            var myObject = JSON.parse(response.data.body);
            successf(myObject);
            //this.props.dispatch(reset('propertyReportLienForm'))
        }
    },
        (error) => {
            errorf(error);
            //this.setState(state => ({ ...state, message: error, showBanner: true }));

        });

}
export const CallAPI = (values, postURL, hostprops, action, errorf, successf) => {
    axios.post(
        postURL,
        JSON.stringify({
            ...values, 
            Action: action,
            UserName: hostprops.session.session.user.name
        }),
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${hostprops.session.session.credentials.accessToken}`
            }
        }
    ).then((response) => {
        console.log(response.data.body);
            if ('data' in response.data.body) {

                var myObject = JSON.parse(response.body.data);
                console.log(myObject);
                successf(myObject);
            
            }
    },
        (error) => {
            errorf(error);
        });
}